import type { IBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/base-model.interface';
import type { INoteModel } from '@src/slide/domain/ui-model/element-modeles/Interface/note-model.interface';
import type { IUiDataService } from '@src/slide/domain/ui-model/service/ui-data-service.interface';
import type { IDrawingShapeDataModel } from '@tencent/slide-sdk-model/src/model/group-shape-data-model';
import type { IEditorInstanceService } from '../editor-instance-service/editor-instance-service.interface';
import type { IMasterLayoutEditService } from '../master-layout-edit-service/master-layout-edit-service.interface';
import type { ISelectionService } from '../selection/selection-service.interface';
import type { IUserPriviledgeService } from '../user-priviledge-service/user-priviledge-service.interface';
import { IToolbarStateManager } from '../toolbar-state-manager/core/toolbar-state-manager.interface';

export enum SearchReplaceType {
    Search = 1,
    Replace = 2,
}

export enum SearchOrder {
    Last = 'last',
    Next = 'next',
}

export class Position {
    public pageIndex: number;
    public component: IDrawingShapeDataModel;
    public offset: number;
}

export interface SearchResultItem {
    offset: number;
    paragraph: number;
    cell?: { row: number; col: number }
}
export type Result = {
    slideIndex: number;
    component: IDrawingShapeDataModel;
    uniqueID: string;
    result: Array<SearchResultItem>;
};


export interface ISearchReplaceManagerServices {
    selectionService: ISelectionService
    userPriviledgeService: IUserPriviledgeService;
    uiDataService: IUiDataService;
    editorInstanceService: IEditorInstanceService;
    masterLayoutEditService: IMasterLayoutEditService;
    toolbarStateManager: IToolbarStateManager
}

/**
 * 查找替换管理器接口。
 */
export interface ISearchReplaceManager {
    /**
     * 切页逻辑，表示主动切页
     */
    changePageFlag: boolean;

    /**
     * 搜索结果数量
     */
    keywordCount: number;

    /**
     * 弹出框状态
     */
    modal: boolean;

    /**
     * 当前高亮搜索结果index
     */
    currentIndex: number;

    /**
     * 当前页搜索结果
     */
    currentPageResult: Array<Result>;

    /**
     * 是否搜索状态
     */
    isSearchingFlag: boolean;

    lastHighlightPosition: Position;
    /**
     * 搜索关键词
     */
    keyword: string;

    dialogOpenFlag: boolean;
    /**
     * 当前查找替换类型
     */
    searchReplaceType: SearchReplaceType;

    init(): void;

    setServiceDelegates(services: ISearchReplaceManagerServices): void;

    /**
     * 获取uimodel
     */
    getUIModelBySDKComponent(
        component: IDrawingShapeDataModel,
        children: Array<IBaseModel>,
        note: INoteModel | undefined,
    )

    /**
     * 打开面板
     * @param type
     */
    openDialog(type: SearchReplaceType);

    /**
     * 当前是否开启无障碍
     */
    closeDialog(): void;

    /**
     * 直接读取某段文字
     * @param type
     */
    changeSearchReplaceType(type: SearchReplaceType);

    /**
     * 获取数据
     * 如果有数据，刷新新的ui（不跳转）
     * @param keyword keyword
     */
    search(keyword: string);

    /**
     * highlight当前的上一个或下一个元素，此时keyword是不会改变的！
     * @param order
     */
    searchHighlight(order: SearchOrder);

    /**
     * 替换
     * @param replaceWord 替换的内容
     */
    replace(replaceWord: string);

    /**
     * 全部替换
     * @param replaceWord 替换的内容
     */
    replaceAll(replaceWord: string);

    /**
     * 清除所有高亮的内容
     */
    clear();

    /**
     * 退出search状态
     * 清除所有高亮
     * 但是keyword，count等继续保留
     */
    exitSearching(): Promise<any>;
    fixTableResult(result: Array<{ offset: number; paragraph: number; cell: { row: number; col: number } }>): Array<{
        textPositions: Array<{ offset: number; paragraph: number }>; cell: { row: number; col: number } }>;
}
